const isServer = (typeof window === 'undefined');

const noop = () => undefined;

function getGlobal(globalProp) {
  if (isServer) {
    if (typeof global !== 'undefined') {
      return global[globalProp];
    }
    return undefined;
  }
  return window[globalProp];
}

function getCookie(cookieName) {
  if (isServer) return undefined;

  const cookie = (
    document.cookie
      .split('; ')
      .map(str => str.split('='))
      .find(([name]) => name === cookieName) || []
  )[1];

  if (cookie !== undefined) {
    return cookie.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
  }
  return cookie;
}

function getOsName() {
  if (isServer) return '';

  if (window.navigator.appVersion.indexOf('Win') !== -1) {
    return 'Windows';
  }
  if (window.navigator.appVersion.indexOf('Mac') !== -1) {
    return 'MacOS';
  }
  if (window.navigator.appVersion.indexOf('X11') !== -1) {
    return 'UNIX';
  }
  if (window.navigator.appVersion.indexOf('Linux') !== -1) {
    return 'Linux';
  }
  return 'Unknown OS';
}

function getBrowserName() {
  if (isServer) return '';

  const useragent = window.navigator.userAgent;
  let revision = '';
  let matchedName =
    useragent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    ) || [];
  if (/trident/i.test(matchedName[1])) {
    revision = /\brv[ :]+(\d+)/g.exec(useragent) || [];
    return `IE ${revision[1] || ''}`;
  }
  if (matchedName[1] === 'Chrome') {
    revision = useragent.match(/\bOPR\/(\d+)/);
    if (revision !== null) {
      return `Opera ${revision[1]}`;
    }
  }
  matchedName = matchedName[2]
    ? [matchedName[1], matchedName[2]]
    : [window.navigator.appName, window.navigator.appVersion, '-?'];
  revision = useragent.match(/version\/(\d+)/i);
  if (revision !== null) {
    matchedName.splice(1, 1, revision[1]);
  }

  return matchedName.join(' ');
}

function getClientProperties() {
  if (isServer) return {};

  return {
    browser: getBrowserName(),
    os: getOsName(),
    deviceCategory: window.WURFL && window.WURFL.form_factor,
    deviceName: window.WURFL && window.WURFL.complete_device_name,
    referrer: document.referrer,
    language: navigator.language,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    browserResolution: `${window.innerWidth}x${window.innerHeight}`,
    url: window.location.href
  };
}

function setGlobal(key, val) {
  if (isServer) return;
  window[key] = val;
  // eslint-disable-next-line consistent-return
  return window[key];
}

function loadExternalScript(url, globalProp, callback = noop) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.onload = async () => {
      const result = await callback(window[globalProp]);
      if (result && !window[globalProp]) {
        setGlobal(globalProp, result);
      }
      resolve(window[globalProp]);
    };
    script.onerror = reject;
    script.src = url;
    document.body.appendChild(script);
  }).catch(() => null);
}

function getAnalyticsClient(globalProp, url, callback) {
  if (!globalProp || isServer) {
    return undefined;
  }
  if (url && !window[globalProp]) {
    return loadExternalScript(url, globalProp, callback);
  }
  return window[globalProp];
}

export {
  isServer,
  setGlobal,
  getGlobal,
  getCookie,
  getOsName,
  getBrowserName,
  loadExternalScript,
  getAnalyticsClient,
  getClientProperties
};
